<template>
  <div :class="{ 'has-logo': true }">
    <!-- Logo -->
    <logo :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <!-- 菜单 -->
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :unique-opened="false"
        :collapse-transition="false"
        mode="vertical"
        active-text-color:-409e-f-f-
      >
        <!-- 菜单项 -->
        <sidebar-item
          v-for="menu in menus"
          :key="menu.code"
          :item="menu"
          :base-path="menu.name"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
// Logo
import Logo from "./Logo"
// 菜单项
import SidebarItem from "./SidebarItem"
import { getUserRole } from '@/utils/routerFilter'
import menuData from "./menu"
import filterMenusByRole from './filterMenu'

export default {
  components: {
    SidebarItem,
    Logo
  },
  data() {
    return {
      menus: null
    }
  },
  computed: {
    ...mapGetters(["sidebar"]),
    // 获取当前路由路径，菜单ID为路径，故路径即为选中标签
    activeMenu() {
      const route = this.$route
      const { path } = route
      return path
    },
    isCollapse() {
      return !this.sidebar.opened
    },
    /**
     * 用户编码
     * @returns {any}
     */
    userCode() {
      return this.$store.getters["user/getUserCode"]
    },
    /**
     * 医生类型
     * @returns {*}
     */
    doctorType() {
      return this.$store.getters["user/getDoctorType"]
    }
  },
  watch: {
    menus(val) {
      this.menus = val
      localStorage.setItem("menudata", JSON.stringify(this.menus))
    }
  },
  created() {
    // 初始化菜单
    this.initMenu()
  },
  methods: {
    /**
     * 初始化菜单
     */
    initMenu() {
      const userInfo = getUserRole()
      console.log(userInfo)

      this.menus = filterMenusByRole(menuData, [userInfo])
    }
  }
}
</script>
<style lang="scss">
@import "~@/styles/variables.scss";

.el-menu {
  background-color: $menuBg !important;
}

.el-submenu__title {
  color: $menuText !important;
}

.el-menu-item {
  color: $menuText;
}
</style>
